module.exports = __webpack_public_path__ + "static/media/about.3f396015.jpg";